import MarkdownPage from "../components/MarkdownPage";

export default function PrivacyPolicyPage() {
    return (
        <MarkdownPage
            title="Privacy Policy – CV Box"
            description="CV Box privacy policy – how we collect, use, and protect your data."
            markdownFile="/content/privacy.md"
        />
    );
}